import { SHAPE_SIZE } from './constants';

/**
 * Per-image size check for the upload tab. The player maps each shape
 * differently (MEASURED), so "wrong size" means different things:
 *  - lshape: ONE image stretched NON-UNIFORMLY to the screen, then windowed —
 *    any aspect other than 16:9 is distorted.
 *  - bottom: CENTER_CROP into a 1920x216 (8.89:1) box — any other aspect is
 *    cropped (a 1920x384 loses 44% of its height).
 *  - corner: FIT_CENTER into a square — non-square images are letterboxed.
 * Returns { ok, level: 'ok'|'bad', reason }.
 */
export function checkImageSize(shape, w, h) {
  const spec = SHAPE_SIZE[shape];
  if (!spec || !w || !h) return { ok: true, level: 'ok', reason: 'unknown' };
  if (w === spec.w && h === spec.h) return { ok: true, level: 'ok', reason: 'exact' };
  const aspect = w / h;
  const want = spec.w / spec.h;
  const sameAspect = Math.abs(aspect - want) / want < 0.01;
  if (sameAspect) return { ok: true, level: 'ok', reason: 'scaled' };
  const reason = shape === 'bottom' ? 'cropped' : shape === 'corner' ? 'letterboxed' : 'distorted';
  return { ok: false, level: 'bad', reason };
}

/** Reads natural pixel size of an image File/Blob/URL. */
export function readImageSize(src) {
  return new Promise((resolve) => {
    const img = new Image();
    let url = null;
    img.onload = () => { if (url) URL.revokeObjectURL(url); resolve({ w: img.naturalWidth, h: img.naturalHeight }); };
    img.onerror = () => { if (url) URL.revokeObjectURL(url); resolve({ w: 0, h: 0 }); };
    if (typeof src === 'string') { img.crossOrigin = 'anonymous'; img.src = src; } else { url = URL.createObjectURL(src); img.src = url; }
  });
}
